import { PerspectiveCamera, Vector3 } from 'three';
import { getAdaptiveConfigurationValue } from '../AdaptiveConfigurationDto';
import { OrbitControls } from './OrbitControls.js';
export class OrbitControlsCameraManager {
    constructor() {
        this.width = 0;
        this.height = 0;
        this.debug = false;
    }
    set enabled(value) {
        this.orbitControls.enabled = value;
    }
    getControlsAzimuthalAngle() {
        return this.orbitControls.getAzimuthalAngle();
    }
    init(configuration, canvas) {
        var _a, _b, _c, _d, _e, _f;
        const params = new URLSearchParams(location.search);
        this.debug = params.get('debug') !== null;
        const parent = canvas.parentElement;
        if (parent) {
            this.height = parent.clientHeight;
            this.width = parent.clientWidth;
        }
        const near = 0.05;
        const farFactor = (_b = (_a = configuration.camera) === null || _a === void 0 ? void 0 : _a.farFactor) !== null && _b !== void 0 ? _b : 2;
        const far = configuration.camera.maxDistance * farFactor;
        this.camera = new PerspectiveCamera(30, this.width / this.height, near, far);
        this.orbitControls = new OrbitControls(this.camera, canvas);
        this.orbitControls.autoZoomDisable = (_d = (_c = configuration.camera) === null || _c === void 0 ? void 0 : _c.autoZoomDisable) !== null && _d !== void 0 ? _d : false;
        if (configuration.camera.position) {
            const position = getAdaptiveConfigurationValue(configuration.camera.position);
            this.camera.position.x = position.x;
            this.camera.position.y = position.y;
            this.camera.position.z = position.z;
        }
        this.orbitControls.enabled = true;
        this.orbitControls.rotateSpeed = 1;
        this.orbitControls.zoomSpeed = 1.5;
        this.orbitControls.minDistance = configuration.camera.minDistance;
        this.orbitControls.maxDistance = configuration.camera.maxDistance;
        this.orbitControls.maxPolarAngle = configuration.camera.maxPolarAngle
            ? (Math.PI / 180) * configuration.camera.maxPolarAngle
            : Math.PI;
        this.orbitControls.minAzimuthAngle = (_e = configuration.camera.minAzimuthAngle) !== null && _e !== void 0 ? _e : Infinity;
        this.orbitControls.maxAzimuthAngle = (_f = configuration.camera.maxAzimuthAngle) !== null && _f !== void 0 ? _f : Infinity;
        if (configuration.camera.enablePan) {
            this.orbitControls.enablePan = true;
        }
        else {
            this.orbitControls.enablePan = false;
        }
        if (configuration.camera.lookAt) {
            const lookAt = getAdaptiveConfigurationValue(configuration.camera.lookAt);
            this.orbitControls.target = new Vector3(lookAt.x, lookAt.y, lookAt.z);
        }
        this.orbitControls.enableDamping = true;
        this.orbitControls.dampingFactor = 0.1;
        this.orbitControls.screenSpacePanning = true;
    }
    updateControlsTarget(target) {
        this.orbitControls.target = target;
    }
    update() {
        if (this.debug) {
            console.log('Camera position', this.camera.position.toArray());
            console.log('Camera lookAt', this.orbitControls.target.toArray());
            console.log('azimuth', this.orbitControls.getAzimuthalAngle());
            console.log('polar', this.orbitControls.getPolarAngle());
        }
        this.orbitControls.update();
    }
    resize(width, height) {
        this.width = width;
        this.height = height;
        this.camera.aspect = this.width / this.height;
        this.camera.updateProjectionMatrix();
    }
}
//# sourceMappingURL=OrbitControlsCameraManager.js.map